import React from 'react';
import i18n from '../../../i18n';
import { makeStyles } from '@material-ui/core/styles';

import { Text, TextTypography } from 'components/Text/Text';

import { LegalDocumentLink } from 'types';

const useStyles = makeStyles(theme => ({
    link: {
        color: theme.palette.fixedPrimary.primary,
    },
}));

export interface TermsAndConditionsProps {
    buttonText: string;
}

export const TermsAndConditions = (props: TermsAndConditionsProps) => {
    const { buttonText } = props;

    const { t } = i18n.useTranslation();
    const classes = useStyles();
    return (
        <div>
            <Text typography={TextTypography.PARA}>{t('common:terms.termsText1', { buttonText })}</Text>{' '}
            <Text typography={TextTypography.PARA_ACCENT}>
                <a
                    className={classes.link}
                    href={LegalDocumentLink.AGREEMENT_FOR_VENDORS}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t('common:terms.termsAgreementLink')}
                </a>
            </Text>{' '}
            <Text typography={TextTypography.PARA}>{t('common:terms.termsText2')}</Text>{' '}
            <Text typography={TextTypography.PARA_ACCENT}>
                <a
                    className={classes.link}
                    href={LegalDocumentLink.PERSONAL_DATA_PROCESSING_CONSENT}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t('common:terms.termsPersonalDataProcessingConsentLink')}
                </a>
            </Text>{' '}
            <Text typography={TextTypography.PARA}>{t('common:terms.termsSms')}</Text>
        </div>
    );
};
